module.exports = __webpack_public_path__ + "static/media/wicketStandart.3826eca0.jpg";